import styled from 'styled-components';

const StyledVideoScroll = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  text-align: right;
  top: 0;
  .video--wrap{
    position: relative;
    width: 83.33%;
    padding-right: 48px;
    margin-left: 8.33%;
    left: 8.33%;
    bottom: -160px;
    overflow: hidden;
  }
  &.right .video--wrap {
    padding-left: 48px;
    padding-right: 0;
    right: 8.33%;
    left: auto;
    margin-left: auto;
    margin-right: 8.33%;
  }
  .video--wrap video{
    position: relative;
    width: 100%;
  }
  @media screen and (max-width: 1023px){
    .video--wrap{
      padding-right: 32px;
      bottom: -128px;
    }
    &.right .video--wrap {
      padding-left: 32px;
      padding-right: 0;
    }
  }
  @media screen and (max-width: 1023px){
    .video--wrap{
      margin: 0 auto;
      padding: 0;
      left: inherit;
      bottom: -80px;
      width: ${props => props.noAnimation ? '100%' : '83.33%'};
      margin-left: ${props => props.noAnimation ? '0' : '8.33%'};
      left: ${props => props.noAnimation ? '0' : '8.33%'};
    }
    &.right .video--wrap {
      padding-left: ${props => props.noAnimation ? '0' : '48px'};
      padding-right: 0;
      right: ${props => props.noAnimation ? '0' : '8.33%'};
      margin-right: ${props => props.noAnimation ? '0' : '8.33%'};
    }
    .video--wrap video{
      position: relative;
      height: auto; 
      width: 100%;
      left: 0;
      transform: translateX(0%);
    }
  }
  
`;

export {
  StyledVideoScroll,
};

